import React, { useState } from 'react';
import { useEditor } from '../../contexts/EditorContext';

const LeftSidebar = () => {
  const { state, actions } = useEditor();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleAddElement = (type) => {
    const editor = document.querySelector('#editor');
    if (editor) {
      let element;
      switch(type) {
        case 'text':
          element = '<p style="margin: 10px 0; padding: 5px;">New text paragraph</p>';
          break;
        case 'heading':
          element = '<h2 style="margin: 20px 0 10px; padding: 5px;">New Heading</h2>';
          break;
        case 'divider':
          element = '<hr style="border: none; border-top: 1px solid #e2e8f0; margin: 20px 0;">';
          break;
        case 'image':
          element = '<div style="text-align: center; margin: 20px 0; padding: 10px; background: #f8fafc; border: 2px dashed #e2e8f0; border-radius: 8px;"><div style="width: 200px; height: 150px; background: #e2e8f0; display: inline-flex; align-items: center; justify-content: center; color: #718096; border-radius: 4px;">Image Placeholder</div><p style="margin-top: 10px; font-size: 12px; color: #94a3b8;">Click to upload image</p></div>';
          break;
        case 'list':
          element = '<ul style="margin: 10px 0; padding-left: 20px;"><li>List item 1</li><li>List item 2</li></ul>';
          break;
        case 'table':
          element = '<table style="width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e2e8f0;"><tr><th style="border: 1px solid #e2e8f0; padding: 8px; background: #f8fafc;">Header 1</th><th style="border: 1px solid #e2e8f0; padding: 8px; background: #f8fafc;">Header 2</th></tr><tr><td style="border: 1px solid #e2e8f0; padding: 8px;">Cell 1</td><td style="border: 1px solid #e2e8f0; padding: 8px;">Cell 2</td></tr></table>';
          break;
        default:
          return;
      }
      
      // Add element to editor
      editor.innerHTML += element;
      
      // Update state
      actions.updatePageContent(editor.innerHTML);
      
      // Scroll to new element
      setTimeout(() => {
        editor.scrollTop = editor.scrollHeight;
      }, 100);
    }
  };

  const handleDeletePage = (index) => {
    if (state.pages.length <= 1) {
      alert('Cannot delete the only page');
      return;
    }
    
    if (window.confirm('Are you sure you want to delete this page?')) {
      actions.deletePage(index);
    }
  };

  const handleDuplicatePage = (index) => {
    actions.duplicatePage(index);
  };

  

  return (
    <div className="left-sidebar" id="leftSidebar">
      <div className="pages-title">
        <span>Pages</span>
       
      </div>
      
      <div className="pages-container" id="pagesContainer">
        {state.pages.map((page, index) => (
          <div 
            className={`page-item ${index === state.currentPageIndex ? 'active' : ''}`}
            key={page.id}
            onClick={() => actions.selectPage(index)}
          >
            <div className="page-header">
              <div className="page-title">{page.title}</div>
              <div className="page-actions">
                <button 
                  className="page-action-btn" 
                  title="Duplicate page"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDuplicatePage(index);
                  }}
                >
                  <i className="fas fa-copy"></i>
                </button>
                {state.pages.length > 1 && (
                  <button 
                    className="page-action-btn delete-page" 
                    title="Delete page"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeletePage(index);
                    }}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                )}
              </div>
            </div>
            <div className="page-preview">
              <div 
                className="page-preview-content"
                dangerouslySetInnerHTML={{ __html: page.content }}
              />
            </div>
          </div>
        ))}
      </div>
      
      <button className="add-page-btn" onClick={actions.addPage}>
        <i className="fas fa-plus"></i> Add New Page
      </button>
      
      <div className="panel" style={{ marginTop: '20px' }}>
        <h3>Add Elements</h3>
        <div className="element-selector">
          <button className="element-btn" onClick={() => handleAddElement('text')}>
            <i className="fas fa-font"></i>
            <span>Text</span>
          </button>
          <button className="element-btn" onClick={() => handleAddElement('heading')}>
            <i className="fas fa-heading"></i>
            <span>Heading</span>
          </button>
          <button className="element-btn" onClick={() => handleAddElement('divider')}>
            <i className="fas fa-minus"></i>
            <span>Divider</span>
          </button>
          <button className="element-btn" onClick={() => handleAddElement('image')}>
            <i className="fas fa-image"></i>
            <span>Image</span>
          </button>
          <button className="element-btn" onClick={() => handleAddElement('list')}>
            <i className="fas fa-list"></i>
            <span>List</span>
          </button>
          <button className="element-btn" onClick={() => handleAddElement('table')}>
            <i className="fas fa-table"></i>
            <span>Table</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar;